module.exports = __webpack_public_path__ + "img/bg-slash.8552ec2.png";